module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "fm_h1"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  }, [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "id": "r_int"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/Introduction#int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction#int"
    }
  }, [_c('i', [_vm._v("Three Midwestern Playwrights and the Provincetown Players")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch1"
  }, [_c('a', {
    attrs: {
      "id": "r_ch1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/Chapter01#ch1"
    }
  }, [_vm._v("1. Three Midwestern Playwrights Discover the New")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch1"
  }, [_c('a', {
    attrs: {
      "id": "r_ch2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/Chapter02#ch2"
    }
  }, [_vm._v("2. Three Midwestern Playwrights Arrive in a Romantic and Miraculous City")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch1"
  }, [_c('a', {
    attrs: {
      "id": "r_ch3"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Floyd Dell Embraces Feminism in Port Royal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch1"
  }, [_c('a', {
    attrs: {
      "id": "r_ch4"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. George Cram Cook Runs for Congress in the Red City of Iowa")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch1"
  }, [_c('a', {
    attrs: {
      "id": "r_ch5"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Susan Glaspell Fights for Free Speech in Freeport")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch1"
  }, [_c('a', {
    attrs: {
      "id": "r_ch6"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/Chapter06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Three Midwestern Playwrights Found a Theatre Company")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "id": "r_con"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/Conclusion#con",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/Conclusion#con",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Three Midwestern Playwrights Venture beyond P-Town")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm2"
  }, [_c('a', {
    attrs: {
      "id": "r_ack"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/Acknowledgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "id": "r_abb"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/Abbreviations#abb",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "id": "r_note"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/Notes#note",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "id": "r_manu"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/Manscript#manu",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Manuscript Collections Consulted")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "id": "r_epi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/Sources#epi",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Sources for Chapter Epigraphs")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "id": "r_work"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/Work_Cited#work",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Works Cited and Consulted")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "id": "r_cook"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/George#cook",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Classified Primary Source Bibliographies Compiled by Tyler Preston")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/George#cook",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("George Cram Cook")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm1"
  }, [_c('a', {
    attrs: {
      "id": "r_gla"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/Susan#gla",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Susan Glaspell")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm1"
  }, [_c('a', {
    attrs: {
      "id": "r_fly"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/Flyed_Dell#fly",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Floyd Dell")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "id": "r_ind"
    }
  }), _c('span', {
    attrs: {
      "href": "#/text/Index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2f62c52","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Contents.vue
// module id = 72
// module chunks = 0